import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "btns"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "w-full p-[10px]"
};
const _hoisted_7 = {
  class: "message-container"
};
const _hoisted_8 = {
  class: "chat-input-box"
};
const _hoisted_9 = {
  class: "prompt-from"
};
const _hoisted_10 = {
  class: "prompt-btns"
};
import { ChatMessageApi } from '@/api/ai/chat/message';
import { ChatConversationApi } from '@/api/ai/chat/conversation';
import ConversationList from './components/conversation/ConversationList.vue';
import ConversationUpdateForm from './components/conversation/ConversationUpdateForm.vue';
import MessageList from './components/message/MessageList.vue';
import MessageListEmpty from './components/message/MessageListEmpty.vue';
import MessageLoading from './components/message/MessageLoading.vue';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { useRoute } from 'vue-router';
import Icon from '@/components/Icon/src/Icon.vue';
/** AI 聊天对话 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiChat'
  },
  __name: 'index',
  setup(__props) {
    const route = useRoute(); // 路由
    const message = useMessage(); // 消息弹窗
    // 聊天对话
    const conversationListRef = ref();
    const activeConversationId = ref(null); // 选中的对话编号
    const activeConversation = ref(null); // 选中的 Conversation
    const conversationInProgress = ref(false); // 对话是否正在进行中。目前只有【发送】消息时，会更新为 true，避免切换对话、删除对话等操作
    // 消息列表
    const messageRef = ref();
    const activeMessageList = ref([]); // 选中对话的消息列表
    const activeMessageListLoading = ref(false); // activeMessageList 是否正在加载中
    const activeMessageListLoadingTimer = ref(); // activeMessageListLoading Timer 定时器。如果加载速度很快，就不进入加载中
    // 消息滚动
    const textSpeed = ref(50); // Typing speed in milliseconds
    const textRoleRunning = ref(false); // Typing speed in milliseconds
    // 发送消息输入框
    const isComposing = ref(false); // 判断用户是否在输入
    const conversationInAbortController = ref(); // 对话进行中 abort 控制器(控制 stream 对话)
    const inputTimeout = ref(); // 处理输入中回车的定时器
    const prompt = ref(); // prompt
    const enableContext = ref(true); // 是否开启上下文
    // 接收 Stream 消息
    const receiveMessageFullText = ref('');
    const receiveMessageDisplayedText = ref('');
    // =========== 【聊天对话】相关 ===========
    /** 获取对话信息 */
    const getConversation = async id => {
      if (!id) {
        return;
      }
      const conversation = await ChatConversationApi.getChatConversationMy(id);
      if (!conversation) {
        return;
      }
      activeConversation.value = conversation;
      activeConversationId.value = conversation.id;
    };
    /**
     * 点击某个对话
     *
     * @param conversation 选中的对话
     * @return 是否切换成功
     */
    const handleConversationClick = async conversation => {
      // 对话进行中，不允许切换
      if (conversationInProgress.value) {
        message.alert('对话中，不允许切换!');
        return false;
      }
      // 更新选中的对话 id
      activeConversationId.value = conversation.id;
      activeConversation.value = conversation;
      // 刷新 message 列表
      await getMessageList();
      // 滚动底部
      scrollToBottom(true);
      // 清空输入框
      prompt.value = '';
      return true;
    };
    /** 删除某个对话*/
    const handlerConversationDelete = async delConversation => {
      // 删除的对话如果是当前选中的，那么就重置
      if (activeConversationId.value === delConversation.id) {
        await handleConversationClear();
      }
    };
    /** 清空选中的对话 */
    const handleConversationClear = async () => {
      // 对话进行中，不允许切换
      if (conversationInProgress.value) {
        message.alert('对话中，不允许切换!');
        return false;
      }
      activeConversationId.value = null;
      activeConversation.value = null;
      activeMessageList.value = [];
    };
    /** 修改聊天对话 */
    const conversationUpdateFormRef = ref();
    const openChatConversationUpdateForm = async () => {
      conversationUpdateFormRef.value.open(activeConversationId.value);
    };
    const handleConversationUpdateSuccess = async () => {
      // 对话更新成功，刷新最新信息
      await getConversation(activeConversationId.value);
    };
    /** 处理聊天对话的创建成功 */
    const handleConversationCreate = async () => {
      // 创建对话
      await conversationListRef.value.createConversation();
    };
    /** 处理聊天对话的创建成功 */
    const handleConversationCreateSuccess = async () => {
      // 创建新的对话，清空输入框
      prompt.value = '';
    };
    // =========== 【消息列表】相关 ===========
    const imageListRef = ref(null);
    // 添加处理消息列表变化的方法
    const handleMessageListChange = async () => {
      await scrollToBottom();
    };
    /** 滚动到 message 底部 */
    const scrollToBottom = async isIgnore => {
      await nextTick();
      if (imageListRef.value) {
        // 直接滚动父容器
        imageListRef.value.scrollTop = imageListRef.value.scrollHeight;
      }
    };
    /** 获取消息 message 列表 */
    const getMessageList = async () => {
      try {
        if (activeConversationId.value === null) {
          return;
        }
        // Timer 定时器，如果加载速度很快，就不进入加载中
        activeMessageListLoadingTimer.value = setTimeout(() => {
          activeMessageListLoading.value = true;
        }, 60);
        // 获取消息列表
        activeMessageList.value = await ChatMessageApi.getChatMessageListByConversationId(activeConversationId.value);
        // 滚动到最下面
        await nextTick();
        await scrollToBottom();
      } finally {
        // time 定时器，如果加载速度很快，就不进入加载中
        if (activeMessageListLoadingTimer.value) {
          clearTimeout(activeMessageListLoadingTimer.value);
        }
        // 加载结束
        activeMessageListLoading.value = false;
      }
    };
    /**
     * 消息列表
     *
     * 和 {@link #getMessageList()} 的差异是，把 systemMessage 考虑进去
     */
    const messageList = computed(() => {
      if (activeMessageList.value.length > 0) {
        return activeMessageList.value;
      }
      // 没有消息时，如果有 systemMessage 则展示它
      if (activeConversation.value?.systemMessage) {
        return [{
          id: 0,
          type: 'system',
          content: activeConversation.value.systemMessage
        }];
      }
      return [];
    });
    /** 处理删除 message 消息 */
    const handleMessageDelete = () => {
      if (conversationInProgress.value) {
        message.alert('回答中，不能删除!');
        return;
      }
      // 刷新 message 列表
      getMessageList();
    };
    /** 处理 message 清空 */
    const handlerMessageClear = async () => {
      if (!activeConversationId.value) {
        return;
      }
      try {
        // 确认提示
        await message.delConfirm('确认清空对话消息？');
        // 清空对话
        await ChatMessageApi.deleteByConversationId(activeConversationId.value);
        // 刷新 message 列表
        activeMessageList.value = [];
      } catch {}
    };
    const handleGoTopMessage = () => {
      if (imageListRef.value) {
        imageListRef.value.scrollTop = 0;
      }
    };
    /** 滚动到 message 列表的底部 */
    const handleGoBottomMessage = () => {
      if (imageListRef.value) {
        imageListRef.value.scrollTop = imageListRef.value.scrollHeight;
      }
    };
    // =========== 【发送消息】相关 ===========
    /** 处理来自 keydown 的发送消息 */
    const handleSendByKeydown = async event => {
      // 判断用户是否在输入
      if (isComposing.value) {
        return;
      }
      // 进行中不允许发送
      if (conversationInProgress.value) {
        return;
      }
      const content = prompt.value?.trim();
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // 插入换行
          prompt.value += '\r\n';
          event.preventDefault(); // 防止默认的换行行为
        } else {
          // 发送消息
          await doSendMessage(content);
          event.preventDefault(); // 防止默认的提交行为
        }
      }
    };
    /** 处理来自【发送】按钮的发送消息 */
    const handleSendByButton = () => {
      doSendMessage(prompt.value?.trim());
    };
    /** 处理 prompt 输入变化 */
    const handlePromptInput = event => {
      // 非输入法 输入设置为 true
      if (!isComposing.value) {
        // 回车 event data 是 null
        if (event.data == null) {
          return;
        }
        isComposing.value = true;
      }
      // 清理定时器
      if (inputTimeout.value) {
        clearTimeout(inputTimeout.value);
      }
      // 重置定时器
      inputTimeout.value = setTimeout(() => {
        isComposing.value = false;
      }, 400);
    };
    // TODO ：是不是可以通过 @keydown.enter、@keydown.shift.enter 来实现，回车发送、shift+回车换行；主要看看，是不是可以简化 isComposing 相关的逻辑
    const onCompositionstart = () => {
      isComposing.value = true;
    };
    const onCompositionend = () => {
      // console.log('输入结束...')
      setTimeout(() => {
        isComposing.value = false;
      }, 200);
    };
    /** 真正执行【发送】消息操作 */
    const doSendMessage = async content => {
      // 校验
      if (content.length < 1) {
        // message.error('发送失败，原因：内容为空！')
        return;
      }
      // 如果没有活动会话，先创建一个
      if (activeConversationId.value == null) {
        // 使用现有的创建会话方法
        await handleConversationCreate();
        // 等待会话创建完成
        let retryCount = 0;
        while (activeConversationId.value == null && retryCount < 50) {
          await new Promise(resolve => setTimeout(resolve, 100));
          retryCount++;
        }
        // 如果还是没有会话ID，说明创建失败
        if (activeConversationId.value == null) {
          message.error('创建对话失败，请重试！');
          return;
        }
      }
      // 清空输入框
      prompt.value = '';
      // 执行发送
      await doSendMessageStream({
        conversationId: activeConversationId.value,
        content: content
      });
    };
    /** 真正执行【发送】消息操作 */
    // 首次对话修改对话标题 todo
    const doSendMessageStream = async userMessage => {
      // 创建 AbortController 实例，以便中止请求
      conversationInAbortController.value = new AbortController();
      // 标记对话进行中
      conversationInProgress.value = true;
      // 设置为空
      receiveMessageFullText.value = '';
      try {
        // 1.1 先添加两个假数据，等 stream 返回再替换
        activeMessageList.value.push({
          id: -1,
          conversationId: activeConversationId.value,
          type: 'user',
          content: userMessage.content,
          createTime: new Date()
        });
        activeMessageList.value.push({
          id: -2,
          conversationId: activeConversationId.value,
          type: 'assistant',
          content: '思考中...',
          createTime: new Date()
        });
        // 1.2 滚动到最下面
        await nextTick();
        await scrollToBottom(); // 底部
        // 1.3 开始滚动
        textRoll();
        // 2. 发送 event stream
        let isFirstChunk = true; // 是否是第一个 chunk 消息段
        await ChatMessageApi.sendChatMessageStream(userMessage.conversationId, userMessage.content, conversationInAbortController.value, enableContext.value, async res => {
          const {
            code,
            data,
            msg
          } = JSON.parse(res.data);
          if (code !== 0) {
            message.alert(`对话异常! ${msg}`);
            return;
          }
          // 如果内容为空，就不处理。
          if (data.receive.content === '') {
            return;
          }
          // 首次返回需要添加一个 message 到页面，后面的都是更新
          if (isFirstChunk) {
            isFirstChunk = false;
            // 弹出两个假数据
            activeMessageList.value.pop();
            activeMessageList.value.pop();
            // 更新返回的数据
            activeMessageList.value.push(data.send);
            activeMessageList.value.push(data.receive);
            // 首次发送消息更新会话标题
            if (data.conversationTitleUpdated) {
              conversationListRef.value?.refreshChatConversationList();
            }
          }
          // debugger
          receiveMessageFullText.value = receiveMessageFullText.value + data.receive.content;
          // 滚动到最下面
          await scrollToBottom();
        }, error => {
          message.alert(`对话异常! ${error}`);
          stopStream();
          // 需要抛出异常，禁止重试
          throw error;
        }, () => {
          stopStream();
        });
      } catch {}
    };
    /** 停止 stream 流式调用 */
    const stopStream = async () => {
      // tip：如果 stream 进行中的 message，就需要调用 controller 结束
      if (conversationInAbortController.value) {
        conversationInAbortController.value.abort();
      }
      // 设置为 false
      conversationInProgress.value = false;
    };
    /** 编辑 message：设置为 prompt，可以再次编辑 */
    const handleMessageEdit = message => {
      prompt.value = message.content;
    };
    /** 刷新 message：基于指定消息，再次发起对话 */
    const handleMessageRefresh = message => {
      doSendMessage(message.content);
    };
    // ============== 【消息滚动】相关 =============
    /** 滚动到 message 底部 */
    // const scrollToBottom = async (isIgnore?: boolean) => {
    //   await nextTick()
    //   if (messageRef.value) {
    //     messageRef.value.scrollToBottom(isIgnore)
    //   }
    // }
    /** 自提滚动效果 */
    const textRoll = async () => {
      let index = 0;
      try {
        // 只能执行一次
        if (textRoleRunning.value) {
          return;
        }
        // 设置状态
        textRoleRunning.value = true;
        receiveMessageDisplayedText.value = '';
        const task = async () => {
          // 调整速度
          const diff = (receiveMessageFullText.value.length - receiveMessageDisplayedText.value.length) / 10;
          if (diff > 5) {
            textSpeed.value = 10;
          } else if (diff > 2) {
            textSpeed.value = 30;
          } else if (diff > 1.5) {
            textSpeed.value = 50;
          } else {
            textSpeed.value = 100;
          }
          // 对话结束，就按 30 的速度
          if (!conversationInProgress.value) {
            textSpeed.value = 10;
          }
          if (index < receiveMessageFullText.value.length) {
            receiveMessageDisplayedText.value += receiveMessageFullText.value[index];
            index++;
            // 更新 message
            const lastMessage = activeMessageList.value[activeMessageList.value.length - 1];
            lastMessage.content = receiveMessageDisplayedText.value;
            // 滚动到住下面
            await scrollToBottom();
            // 重新设置任务
            timer = setTimeout(task, textSpeed.value);
          } else {
            // 不是对话中可以结束
            if (!conversationInProgress.value) {
              textRoleRunning.value = false;
              clearTimeout(timer);
            } else {
              // 重新设置任务
              timer = setTimeout(task, textSpeed.value);
            }
          }
        };
        let timer = setTimeout(task, textSpeed.value);
      } catch {}
    };
    /** 初始化 **/
    onMounted(async () => {
      // 如果有 conversationId 参数，则默认选中
      if (route.query.conversationId) {
        const id = route.query.conversationId;
        activeConversationId.value = id;
        await getConversation(id);
      }
      // 获取列表数据
      activeMessageListLoading.value = true;
      await getMessageList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "ai-layout"
      }, {
        default: _withCtx(() => [_createVNode(ConversationList, {
          "active-id": activeConversationId.value,
          ref_key: "conversationListRef",
          ref: conversationListRef,
          onOnConversationCreate: handleConversationCreateSuccess,
          onOnConversationClick: handleConversationClick,
          onOnConversationClear: handleConversationClear,
          onOnConversationDelete: handlerConversationDelete
        }, null, 8, ["active-id"]), _createVNode(_component_el_card, {
          class: "dr-task",
          "body-class": "task-card",
          shadow: "never"
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(activeConversation.value?.title ? activeConversation.value?.title : '对话') + " ", 1), activeMessageList.value.length ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(activeMessageList.value.length) + ")", 1)) : _createCommentVNode("", true)]), activeConversation.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_button, {
            type: "primary",
            bg: "",
            plain: "",
            size: "small",
            onClick: openChatConversationUpdateForm
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              innerHTML: activeConversation.value?.modelName
            }, null, 8, _hoisted_5), _createVNode(Icon, {
              icon: "ep:setting",
              class: "ml-10px"
            })]),
            _: 1
          }), _createVNode(_component_el_button, {
            size: "small",
            class: "btn",
            onClick: handlerMessageClear
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: "heroicons-outline:archive-box-x-mark",
              color: "#787878"
            })]),
            _: 1
          }), _createVNode(_component_el_button, {
            size: "small",
            class: "btn",
            onClick: handleGoBottomMessage
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: "ep:download",
              color: "#787878"
            })]),
            _: 1
          }), _createVNode(_component_el_button, {
            size: "small",
            class: "btn",
            onClick: handleGoTopMessage
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: "ep:top",
              color: "#787878"
            })]),
            _: 1
          })])) : _createCommentVNode("", true)])]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "task-image-list",
            ref_key: "imageListRef",
            ref: imageListRef
          }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [activeMessageListLoading.value ? (_openBlock(), _createBlock(MessageLoading, {
            key: 0
          })) : _createCommentVNode("", true), !activeConversation.value || !activeMessageListLoading.value && messageList.value.length === 0 && activeConversation.value ? (_openBlock(), _createBlock(MessageListEmpty, {
            key: 1,
            onOnPrompt: doSendMessage
          })) : _createCommentVNode("", true), !activeMessageListLoading.value && messageList.value.length > 0 ? (_openBlock(), _createBlock(MessageList, {
            key: 2,
            ref_key: "messageRef",
            ref: messageRef,
            conversation: activeConversation.value,
            list: messageList.value,
            onOnDeleteSuccess: handleMessageDelete,
            onOnEdit: handleMessageEdit,
            onOnRefresh: handleMessageRefresh,
            onOnListChange: handleMessageListChange
          }, null, 8, ["conversation", "list"])) : _createCommentVNode("", true)])])], 512), _createElementVNode("div", _hoisted_8, [_createElementVNode("form", _hoisted_9, [_withDirectives(_createElementVNode("textarea", {
            class: "prompt-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
            onKeydown: handleSendByKeydown,
            onInput: handlePromptInput,
            onCompositionstart: onCompositionstart,
            onCompositionend: onCompositionend,
            placeholder: "问我任何问题...（Shift+Enter 换行，按下 Enter 发送）"
          }, null, 544), [[_vModelText, prompt.value]]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_switch, {
            modelValue: enableContext.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => enableContext.value = $event),
            "active-text": "上下文"
          }, null, 8, ["modelValue"]), conversationInProgress.value == false ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "default",
            onClick: handleSendByButton,
            loading: conversationInProgress.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(conversationInProgress.value ? '进行中' : '发送'), 1)]),
            _: 1
          }, 8, ["loading"])) : _createCommentVNode("", true), conversationInProgress.value == true ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "danger",
            size: "default",
            onClick: _cache[2] || (_cache[2] = $event => stopStream())
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 停止 ")])),
            _: 1
          })) : _createCommentVNode("", true)])])])]),
          _: 1
        }), _createVNode(ConversationUpdateForm, {
          ref_key: "conversationUpdateFormRef",
          ref: conversationUpdateFormRef,
          onSuccess: handleConversationUpdateSuccess
        }, null, 512)]),
        _: 1
      });
    };
  }
});